<template>
  <ButtonArrow class="login-button" data-toggle="modal" data-target="#loginModal"> Log in to your account </ButtonArrow>
</template>

<script>
import ButtonArrow from '../button-arrow/ButtonArrow'
export default {
  name: 'LoginButton',
  components: { ButtonArrow },
}
</script>



// WEBPACK FOOTER //
// src/components/reused-components/login-button/LoginButton.vue